import { render, staticRenderFns } from "./RecordingServers.vue?vue&type=template&id=4dc034aa&scoped=true"
import script from "./RecordingServers.vue?vue&type=script&lang=js"
export * from "./RecordingServers.vue?vue&type=script&lang=js"
import style0 from "./RecordingServers.vue?vue&type=style&index=0&id=4dc034aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc034aa",
  null
  
)

export default component.exports